import { render } from "./TheLogistikInfo.vue?vue&type=template&id=1d3f77c6&scoped=true"
import script from "./TheLogistikInfo.vue?vue&type=script&lang=js"
export * from "./TheLogistikInfo.vue?vue&type=script&lang=js"

import "./TheLogistikInfo.vue?vue&type=style&index=0&id=1d3f77c6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3f77c6"]])

export default __exports__